import React, { useContext, useEffect, useState } from 'react'
import { Breadcrumb, Heading, ContentDropDown, Spinner } from '../common/atoms'
import { ManageEmployeeModel, SuccessModal } from '../modals'
import { UserAlert } from '../common/atoms/alerts'
import { Table } from '../common/molecules'
import { UploadCard, SearchBarCard } from '../common/organisms'
import { AppStateContext, AppDispatchContext } from '../../utils/contexts'
import { employeeDataApi } from '../../services'
import { handleAppError } from '../handlers'
import { DRAGGER_CONTENT, FAQS } from '../../constants/employeeData'
import { deleteTableSchema as schema, manageEmployeeTableSchema } from '../../schemas/table'
import { recentSearchSchema as recent_table_schema } from '../../schemas/table'
import {DELETE_EMPLOYEE_HEADERS, RECENT_UPLOADS_HEADERS as HEADERS} from '../../constants/tableHeaders'
import { useHistory } from 'react-router-dom'

const DeleteEmployeesPage = () => {
  const {employee_data : state} = useContext(AppStateContext)
  const dispatch = useContext(AppDispatchContext)
  const [localstate, setLocalState] = useState({
    data: null,
    showDeactivateModal: false,
    showSuccessModal: false,
    disableCancle: false,
    id: null,
    value: null,
    emailValue: '',
    empcodeValue: '',
    loader : false,
    openModel : false,
    employeeName : '',
  })
  const [recentUploads, setRecentUploads] = useState([])
  const [viewMoreFlag, setViewMoreFlag] = useState(false)
  const history = useHistory()

  const fetchRecentUploads = async () => {
    try {
      let result = await employeeDataApi.fetch_deactivate_recent_uploads()
      let data = result.data.customer_data_deletion
      setRecentUploads(data || [])
    } catch (err) {
      handleAppError(err)
    }
  }

  const searchAction = async (value) => {
    setLocalState({...localstate , loader : true })
    const options = {
      params: {
        q: value,
      },
    }

    employeeDataApi.search_employees(
      options,
      (res) => {
        onSearchSuccess(res, value)
      },
      onSearchError
    )
  }

  const toggleModal = (id, action) => {
    let subState = {}
    if (action === 'delete') {
      subState = { showDeactivateModal: true, id: id }
    } else {
      subState = { showDeactivateModal: false, disableCancle: false }
    }
    setLocalState((localstate) => {
      return { ...localstate, ...subState }
    })
  }

  const onSearchSuccess = (result, value) => {
    let data = result.data.meta.customers?.map((element, index) => {
      return {
        key: index + 1,
        ...element,
        handler: toggleModal,
      }
    })
    data = data.length > 0 ? data : null

    setLocalState((localstate) => {
      return { ...localstate, data: data, value: value, loader : false, openModel : false }
    })
  }

  const onSearchError = (error) => {
    setLocalState((localstate) => {
      return { ...localstate, data: null }
    })
    handleAppError(error)
  }

  const deactivateAction = async (request) => {
    const options = {
      id: localstate.id,
    }

    await request(
      options,
      () => {
        toggleModal()
        searchAction(localstate.value)
      },
      (error) => {
        toggleModal()
        handleAppError(error)
      }
    )
  }

  const deleteAction = (type) => {
    if (type === 'yes') {
      deactivateAction(employeeDataApi.delete)
      setLocalState((localstate) => {
        return { ...localstate, disableCancle: true }
      })
    }
    else toggleModal()
  }

  const uploadRequest = (info) => {
    dispatch({ type: 'employee_data', file: info.file })
    history.push('/employee-data/file-upload?of=employee_deactivation')
  }

  const searchValueHandler = (ind, value) => {
    let substate = {}
    if(ind === 0) substate = {emailValue: value, empcodeValue: ''}
    if(ind === 1) substate = {emailValue: '', empcodeValue: value}

    setLocalState(prevState => {
      return {...prevState, ...substate}
    })
  }

  useEffect(() => {
    if (state.pathId !== '0124') dispatch({ type: 'employee_data', file: null, tabledata: null, pathId: '0124' })
    if (state.click_dragger) {
      setTimeout(() => {
        const dragger = document.getElementById('dragger')
        dragger.click()
        dispatch({ type: 'toggle dragger click' })
      }, 0)
    }
    if(state.tabledata) dispatch({ type: '', showDeleteIcon: true })
    fetchRecentUploads()
  }, [])

  const viewRecentHandler = (id) => {
    history.push('/employee-data/view-result?of=employee_deactivation', {id})
  }
  
  const editHandler = (data) => {
    history.push('/manage-employee/edit', { data: JSON.stringify(data) });
  };

  const closeModel = (e, id, name) =>{
    let value = e.value ? 'Active' : 'Inactive'
    if(value === 'Inactive'){
      setLocalState ({...localstate,  openModel : !state.openModel, id : id, employeeName : name})
    }
  }

  return (
    <React.Fragment>
      <Breadcrumb
        list={[
          { text: 'Manage Employees', link: '/employee-registration' },
          { text: 'Deactivate Employees', link: '/deactivate-employees' },
        ]}
        classes='mb-1'
      />
      <Heading mainHeading='Deactivate Employees' mainClasses='font-fig-extrabold text-3xl font-medium leading-tight tracking-tight text-gray-900 sm:text-4xl' />
      {state.tabledata && (
        <UserAlert
          icon='red'
          para='Your file has been processed. There are some validation error in the data.'
          btntext='View Error'
          btnHandler={() => history.push('/employee-data/view-errors?of=employee_deactivation')}
          classes='border border-red-600 py-3 px-4 mt-8'
          paraClasses='text-gray-700 leading-4 font-semibold '
        />
      )}
      <SearchBarCard
        onValueChange={searchValueHandler}
        searchAction={searchAction}
        heading='Deactivate Employees by search'
        description='You can deactivate employee by searching the employee.'
        searchList={['Search by email address', 'Search by employee code']}
        searchValues={[localstate.emailValue, localstate.empcodeValue]}
        classes='mt-8'
      />
      {localstate.data && (
        <div className='mt-8'>
          <Spinner visible={state.loader} classes='relative'>
            <p className='tracking-widest text-xs text-gray-500  font-semibold mb-3'>SEARCH RESULTS</p>          
            <Table
              data ={localstate.data ?? []}
              tableClasses='alternate_gray200_color'              
              classes='rounded-lg'   
              headers={DELETE_EMPLOYEE_HEADERS}
              tableschema={manageEmployeeTableSchema}
              history={history}
              moveToEditEmployee={editHandler}
              openModel= {closeModel}
            />
          </Spinner>
        </div>
      )}
        
      <UploadCard CONTENT={DRAGGER_CONTENT['deactivate']} uploadRequest={uploadRequest} classes='mt-12' listHeading={["Download CSV File","Download XLSX File"]} />
      <p className='tracking-widest text-xs text-gray-500  font-semibold mb-3 mt-12'>RECENT ACTIVITY</p>
      <Table classes='rounded-md' tableClasses='alternate_gray200_color' loading={false} loaderHeight={300} type='deactivate' headers={HEADERS} data={viewMoreFlag ? recentUploads:recentUploads.slice(0, 3)} tableschema={recent_table_schema} handler={viewRecentHandler} />
      {recentUploads.length > 3  && <span className='text-base font-semibold text-blue-500 mt-4 block cursor-pointer' onClick={() => setViewMoreFlag(flag => !flag)}>VIEW {viewMoreFlag ? 'LESS':'MORE'}</span>}
      <div className='flex mt-12'>
        <div className='w-1/2'>
          <h1 className='text-lg font-semibold text-gray-700'>Frequently asked questions</h1>
          <p className='mb-0 mt-2 text-gray-600'>Can’t find the answer you’re looking for?</p>
          <p className='mb-0 text-gray-600'>
            Reach out to our <span className='font-semibold text-blue-500'>customer success manager.</span>
          </p>
        </div>
        <div className='w-1/2'>
          {FAQS['deactivate'].map((item, ind) => {
            return <ContentDropDown key={item.title} {...item} classes={ind === 0 ? '' : 'mt-6'} />
          })}
        </div>
      </div>


      <SuccessModal
        visible={localstate.showSuccessModal}
        title='File has been uploaded successfully'
        para1='We are processing the data, you will receive a confirmation mail within an hour.'
        para2='If the data registration fails you will receice a failed registration email, please verify the data and than upload the correct data.'
        close={() =>
          setLocalState((prevState) => {
            return { ...prevState, showSuccessModal: false }
          })
        }
      />  
      { localstate.openModel  && 
        <ManageEmployeeModel
          visible={localstate.openModel} 
          title={`Are you sure you want to deactivate employee "${localstate.employeeName}" ?`} 
          description='Deactivating the employee will revoke the employee’s access to ekincare app. Once you deactivate, you can’t reactivate the employee.'
          onCancel={() => {
            setLocalState({...localstate, openModel : false}) 
          } } 
          handler={() => deleteAction('yes')}
        />
      }
    </React.Fragment>
  )
}

export default React.memo(DeleteEmployeesPage)
